import { useStaffText } from './StaffText'

export function ConnectionBadge({ status }: { status: 'connecting' | 'live' | 'reconnecting' }) {
  const { say } = useStaffText()
  const label = status === 'live' ? say('common.live') : status === 'connecting' ? say('common.connecting') : say('common.reconnecting')
  return (
    <span className={`status status--${status}`} role="status">
      <span className="status__dot" />
      {label}
    </span>
  )
}
